<template>
  <el-dialog :title="dataForm.id ? 'Edit Bank Account' : 'Add Bank Account'" :close-on-click-modal="false" :visible.sync="visible" width="900px" top="2vh">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" autocomplete="off" label-position="top">
      <el-row :gutter="10">
        <el-col :span="24">
          <copy-from
            :dataForm="dataForm"
            :options="bankAccountList"
            :labelFormatter="item => `${item.tag}-${item.bankName}(${item.accountNumber})`"
            @copyFromTrigger="copyFromTrigger"
          />
        </el-col>
        <el-col :span="12">
          <el-form-item label="Supplier" prop="supplierId">
            <el-select v-model="dataForm.supplierId" filterable clearable placeholder="Select Supplier" class="wdb100" @change="supplierChange">
              <el-option v-for="item in supplierList" :key="`bank-account-modal-${item.id}`" :label="item.companyName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Tag / Label" prop="tag">
            <el-input v-model="dataForm.tag" clearable placeholder="e.g. DBS SGD, PayNow"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Bank Name" prop="bankName">
            <el-input v-model="dataForm.bankName" clearable placeholder="e.g. DBS Bank"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Bank Address" prop="bankAddress">
            <el-input v-model="dataForm.bankAddress" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Swift Code" prop="swiftCode">
            <el-input v-model="dataForm.swiftCode" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="payNowLabel" prop="payNowUen">
            <el-input v-model="dataForm.payNowUen" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Account Number" prop="accountNumber">
            <el-input v-model="dataForm.accountNumber" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Currency" prop="billingCurrency">
            <el-select v-model="dataForm.billingCurrency" filterable clearable placeholder="Select Currency" class="wdb100">
              <el-option v-for="item in currencyList" :key="item.currency" :label="item.currency" :value="item.currency"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="Account Name" prop="accountName">
            <el-input v-model="dataForm.accountName" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="Address of Beneficiary" prop="addressOfBeneficiary">
            <el-input v-model="dataForm.addressOfBeneficiary" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="qrcodeInfoList">
            <span slot="label">
              QR Codes
              <el-popover trigger="hover" content="PayNow / Other">
                <i slot="reference" class="el-icon-info"></i>
              </el-popover>
            </span>
            <div class="uploadWrap">
              <div class="addUploadBtn">
                <el-button type="primary" icon="el-icon-plus" size="mini" plain @click="addHandle">Add QR Code</el-button>
              </div>
              <div class="wdb100 uploadItem" v-for="(item, index) in dataForm.qrcodeInfoList" :key="`qrcodeInfo-${index}`">
                <div class="title">
                  <p class="">QR Code</p>
                  <el-button type="danger" icon="el-icon-delete" size="mini" plain @click="deleteHandle(index)"></el-button>
                </div>
                <div class="pb4">
                  <el-form-item
                    :prop="`qrcodeInfoList.${index}.url`"
                    :rules="{
                      required: true,
                      message: 'please upload',
                      trigger: 'submit',
                    }"
                  >
                    <div class="imageUploadBorder">
                      <el-image-uploader v-model="dataForm.qrcodeInfoList[index]"></el-image-uploader>
                    </div>
                  </el-form-item>
                </div>
                <el-input v-model="dataForm.qrcodeInfoList[index].remark" clearable placeholder="QR description"></el-input>
              </div>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">Cancel</el-button>
      <el-button type="primary" :loading="submitLoading" @click="dataFormSubmit">OK</el-button>
    </span>
  </el-dialog>
</template>

<script>
import CopyFrom from "@/components/CopyFrom";
import { mapState } from "vuex";
export default {
  components: {
    CopyFrom,
  },
  props: {
    bankAccountList: {
      type: Array,
      default: () => [],
    },
    supplierList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      visible: false,
      dataForm: {
        id: null,
        supplierId: "",
        tag: "",
        bankName: "",
        bankAddress: "",
        swiftCode: "",
        payNowUen: "",
        accountNumber: "",
        billingCurrency: "",
        accountName: "",
        addressOfBeneficiary: "",
        qrcodeInfoList: [],
      },
      dataRule: {
        supplierId: [{ required: true, message: "please select", trigger: "submit" }],
        tag: [{ required: true, message: "please enter", trigger: "submit" }],
        bankName: [{ required: true, message: "please enter", trigger: "submit" }],
        accountNumber: [{ required: true, message: "please enter", trigger: "submit" }],
        billingCurrency: [{ required: true, message: "please select", trigger: "submit" }],
      },
      submitLoading: false,
    };
  },
  computed: {
    ...mapState("currency", ["currencyList"]),
    payNowLabel() {
      // 国家与label映射表，后期增加国家只需在此添加
      const labelMap = {
        Singapore: "PayNow UEN",
        Malaysia: "DuitNow BRN",
      };
      // 根据supplierId从supplierList中查找国家
      const target = this.supplierList.find(ele => ele.id === this.dataForm.supplierId);
      const country = target?.country;
      // supplierId为空或国家不在映射表中时，默认返回 PayNow UEN
      return labelMap[country] || "PayNow UEN";
    },
  },
  methods: {
    async init(data) {
      this.visible = true;
      this.submitLoading = false;
      // 需要手动设置qrcodeInfoList为[],不然会报错
      this.$set(this.dataForm, "qrcodeInfoList", []);
      await this.$nextTick();
      this.$refs["dataForm"].resetFields();
      if (data) {
        const dataCopy = JSON.parse(JSON.stringify(data));
        this.dataForm = {
          id: dataCopy.id,
          supplierId: dataCopy?.supplier?.id || "",
          tag: dataCopy.tag,
          bankName: dataCopy.bankName,
          bankAddress: dataCopy.bankAddress,
          swiftCode: dataCopy.swiftCode,
          payNowUen: dataCopy.payNowUen,
          accountNumber: dataCopy.accountNumber,
          billingCurrency: dataCopy.billingCurrency,
          accountName: dataCopy.accountName,
          addressOfBeneficiary: dataCopy.addressOfBeneficiary,
          qrcodeInfoList: dataCopy.qrcodeInfoList || [],
        };
      } else {
        this.$set(this.dataForm, "id", null);
      }
    },
    // 表单提交
    async formSubmitRequest() {
      if (this.dataForm.id) {
        return await this.$http.put(`/admin/supplierBankAccount/${this.dataForm.id}`, this.dataForm);
      } else {
        return await this.$http.post("/admin/supplierBankAccount", this.dataForm);
      }
    },
    dataFormSubmit() {
      console.log(this.dataForm.qrcodeInfoList);
      this.$refs["dataForm"].validate(async valid => {
        if (valid) {
          this.submitLoading = true;
          this.formSubmitRequest()
            .then(res => {
              this.$message({
                message: "success",
                type: "success",
                duration: 1500,
                onClose: () => {
                  this.visible = false;
                  this.$emit("refreshDataList");
                },
              });
            })
            .catch(err => {
              this.submitLoading = false;
            });
        }
      });
    },
    // 添加
    addHandle() {
      this.dataForm.qrcodeInfoList.push({
        url: "",
        remark: "",
      });
    },
    // 删除
    deleteHandle(index) {
      this.dataForm.qrcodeInfoList.splice(index, 1);
    },
    // 接收复制完成的数据
    copyFromTrigger(originalData, newDataForm) {
      newDataForm.supplierId = originalData?.supplier?.id || "";
      this.dataForm = newDataForm;
    },
    // supplier选中时
    supplierChange(id) {
      const target = this.supplierList.find(ele => ele.id === id);
      if (!target) return;
      const { companyName = "", billingAddress = "", country = "", postCode = "" } = target;
      const addressParts = [billingAddress, country, postCode].filter(Boolean);
      const addressOfBeneficiary = addressParts.join(", ");
      this.$set(this.dataForm, "accountName", companyName);
      this.$set(this.dataForm, "addressOfBeneficiary", addressOfBeneficiary);
    },
  },
};
</script>

<style lang="scss" scoped>
.uploadWrap {
  margin-top: 6px;
  position: relative;

  .addUploadBtn {
    position: absolute;
    top: -39px;
    right: 0px;

    ::v-deep {
      .el-checkbox {
        vertical-align: middle;

        .el-checkbox__label {
          font-size: 13px !important;
        }
      }
    }
  }

  .uploadItem {
    border: 1.5px dashed #87cff0;
    border-radius: 4px;
    padding: 12px;
    margin-bottom: 8px;

    .title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 10px;

      p {
        margin: 0;
        line-height: 1em;
        font-size: 13px;
      }
    }

    .imageUploadBorder {
      width: 100%;
      padding: 8px;
      border: 1.5px solid #d0e8f5;
      border-radius: 2px;
      font-size: 13px;
    }
  }
}
</style>
